import { InteractivePythonBlock } from '../components/ui/InteractivePythonBlock';

export default function PythonTestPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
          Python Playground
        </h1>

        <div className="prose prose-lg dark:prose-invert max-w-none mb-6">
          <p className="text-gray-700 dark:text-gray-300">
            Try the toolkit-style Python code live in your browser. Edit the code, hit
            “Run”, and see the results instantly.
          </p>
        </div>

        <div className="flex flex-wrap gap-3 mb-10">
          <a
            href="/cashfx"
            className="inline-flex items-center rounded-lg bg-navy-800 px-4 py-2 text-sm font-semibold text-white hover:bg-navy-700"
          >
            Explore FX Cash Toolkit
          </a>
          <a
            href="/derivatives-toolkits"
            className="inline-flex items-center rounded-lg border border-navy-800 px-4 py-2 text-sm font-semibold text-navy-800 hover:bg-navy-50 dark:border-gold-400 dark:text-gold-200 dark:hover:bg-navy-800"
          >
            Explore Derivatives Toolkits
          </a>
        </div>

        <InteractivePythonBlock filename="portfolio_test.py" title="Portfolio Risk Calculation">
{`import numpy as np

# Sample portfolio data
returns = np.array([0.08, 0.12, 0.15])  # Expected returns
weights = np.array([0.4, 0.35, 0.25])   # Portfolio weights
volatilities = np.array([0.16, 0.20, 0.25])  # Asset volatilities

# Correlation matrix
correlation_matrix = np.array([
    [1.0, 0.6, 0.4],
    [0.6, 1.0, 0.5],
    [0.4, 0.5, 1.0]
])

# Calculate portfolio expected return
portfolio_return = np.sum(weights * returns)
print(f"Portfolio Expected Return: {portfolio_return:.2%}")

# Calculate portfolio volatility
covariance_matrix = np.outer(volatilities, volatilities) * correlation_matrix
portfolio_variance = np.dot(weights, np.dot(covariance_matrix, weights))
portfolio_volatility = np.sqrt(portfolio_variance)

print(f"Portfolio Volatility: {portfolio_volatility:.2%}")
print(f"Sharpe Ratio (assuming 3% risk-free rate): {(portfolio_return - 0.03) / portfolio_volatility:.3f}")

# Risk contribution analysis
risk_contributions = weights * np.dot(covariance_matrix, weights) / portfolio_variance
print("\\nRisk Contributions:")
for i, contrib in enumerate(risk_contributions):
    print(f"Asset {i+1}: {contrib:.1%}")
`}
        </InteractivePythonBlock>

        <div className="mt-8 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
          <h3 className="text-lg font-semibold text-blue-900 dark:text-blue-100 mb-2">
            Tips for getting started
          </h3>
          <ul className="text-blue-800 dark:text-blue-200 space-y-1">
            <li>Edit numbers or arrays to explore scenarios.</li>
            <li>Use the Run button to execute the code.</li>
            <li>Copy working snippets into your local toolkit.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
